import { render, staticRenderFns } from "./editFtpTemplate.vue?vue&type=template&id=3d67bd89&scoped=true"
import script from "./editFtpTemplate.vue?vue&type=script&lang=js"
export * from "./editFtpTemplate.vue?vue&type=script&lang=js"
import style0 from "./editFtpTemplate.vue?vue&type=style&index=0&id=3d67bd89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d67bd89",
  null
  
)

export default component.exports